import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant',
  },
})
export class BadgeComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'new',
      'dot',
      'unread',
      'optional',
      'notifications',
      'counter',
      'active',
      'outline',
      'success',
      'white-bg',
      'scale',
      'gold',
      'overdue',
    ],
  ];
  @ComponentVariant(BadgeComponent.VARIANTS)
  @Input()
  public variant: string;
}
